import { Navigate } from 'react-router-dom'

function ProtectedRoute({ user, children } : {user: string | null | undefined, children: React.ReactNode}) {
  if (!user) {
    return <Navigate to="/logga-in" />
  }
  return <>{children}</>
}

export default ProtectedRoute
